import { Component, OnInit, Input, ChangeDetectorRef, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Subject, merge } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { SvgIconComponent } from '@ngneat/svg-icon';
import { RouterLink } from '@angular/router';
import { NTSTranslatePipe } from '../../pipe/nts-translation-pipe';
import { TextButtonComponent } from '../../shared/buttons/text-button/text-button.component';
import type { CoreOrchestratorViewModelInterface, MessageContainerInterface } from '@nts/std/interfaces';

@Component({
  selector: 'nts-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SvgIconComponent,
    RouterLink,
    NTSTranslatePipe,
    TextButtonComponent
  ]
})
export class NotificationComponent implements OnInit, OnDestroy {

  @Input() orchestratorViewModel: CoreOrchestratorViewModelInterface;

  private destroy$: Subject<boolean> = new Subject<boolean>();
  defaultItemToShow = 1;
  itemToShow = this.defaultItemToShow;

  constructor(private readonly cd: ChangeDetectorRef) {

  }

  ngOnInit() {

    merge(
      this.orchestratorViewModel.eventDispatcher.onRemovedMessageInViewModel,
      this.orchestratorViewModel.eventDispatcher.onRefreshMessageInViewModel,
      this.orchestratorViewModel.eventDispatcher.onAddMessageInViewModel,
      this.orchestratorViewModel.eventDispatcher.onClearMessagesInViewModel,
      this.orchestratorViewModel.eventDispatcher.onClearAllMessages
    ).pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.cd.detectChanges();
    });
  }

  showMore() {
    this.itemToShow = this.orchestratorViewModel?.allViewModelInformationsBuildedList?.length;
  }

  showLess() {
    this.itemToShow = this.defaultItemToShow;
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    // Now let's also unsubscribe from the subject itself:
    this.destroy$.unsubscribe();
  }

  removeMessage(event, information: MessageContainerInterface) {
    event.preventDefault();
    this.orchestratorViewModel.removeMessageInViewModel(information);
  }
}
